import React, { useState, useEffect } from "react";
import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import ListFilters from "../../../Admin/OnBoardManagement/ListFilters";
import editIcon from "../../../../../Assets/icons/printer.svg";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import ListLogisticsFilters from "../../LogisticsFilter";
import Serial from "../../PhysicalStockTaking/PhysicalStockinComponents/Serial";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import Drawer from "react-modern-drawer";
import AddReceipt from "./AddReceipt";
import Loader from "../../../../customComponents/CustomLoader";

const ReceiptList = () => {
  const [jobCardInvoiceData, setJobCarInvoiceData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [receiptDrawer, setreceiptDrawer] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [filterFormData, setFilterFormData] = useState({});

  const [filters, setFilters] = useState({});
  const [isOpen, setIsOpen] = React.useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
    if (isEdit) {
      setIsEdit(!isEdit);
    }
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardInvoiceList(newPage);
  };
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    if(event.target.value==""){
      fetchJobCardInvoiceList()
    }
  };

  const handleEdit = (rowData) => {
    navigate("receipt-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const fetchJobCardInvoiceList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/popaymentreciptinvoice/list",
        {
          orderBy: "po_recvinvoice_id desc",
          page,
          pageSize,
          startDate: null,
          endDate: null,
          searchText: searchQuery,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data?.data?.data?.map((item, index) => ({
        ...item,
        Sr_No: index + 1,
        Payment_Status: "Pending",
        // job_card_no:onClickNavigetion(item),
      }));
      setJobCarInvoiceData(formattedData);
     
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
    finally{
      setLoading(false)
    }
  };

  const TABLE_HEADERS = [
    "Invoice No.",
    "PO No.",
    "Vendor Name",
    "Logistic Type",
    "Name",
    "Total Amt.",
    "Payments Status",
    "Action",
  ];

  const KEY_MAPPING = {
    "Invoice No.": "invoice_no",
    "PO No.": "po_number",
    "Vendor Name": "companyname",
    "Logistic Type": "item",
    Name: "name",
    "Total Amt.": "totalprice",
    "pending Amount": "balance_amount",
    "Payments Status": "payment_status",
    Action: [
      {
        type: "downloadinvoice",
        icon: downloadIcon,
        label: "download Icon",
      },
      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    ],
  };
  useEffect(() => {
    fetchJobCardInvoiceList();
  }, []);

  useEffect(() => {
    fetchJobCardInvoiceList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardInvoiceList();
  };

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };
  const handleKeyPress = (e) => {
    console.log("event",e);
    
    if (e.key === 'Enter') {
      fetchJobCardInvoiceList(0, 10,searchQuery); 
    }
  }  

  const handleDownloadInvoice = async (row) => {
    try {
      const encodedPoDetailsId = btoa(row?.po_details_id.toString());

      const url = `http://127.0.0.1:8596/api/v1/purchaseorder/purchaseOrderDetailsDownload/${encodedPoDetailsId}`;

      window.open(url, "_blank");
    } catch (error) {
      console.log(error);
    }
  };
console.log("jobCardInvoiceData",jobCardInvoiceData);

  return (
    
 
       <div>
      {loading ? ( 
        <Loader />
      ) : (
      <><div className="OnboardManagamentContainer ">
            <div className="ReceiptContainer  mt-2 mb-2">
              <h5>Payment Against Invoice</h5>
            </div>
            <div className=" mt-2 mb-2 totalvaluescontainer ">
              <div className="topleftdataContainer">
                <div className="listTopDataValueText">{jobCardInvoiceData?.total_po_invoce||0}</div>
                <div>Total Receipt</div>
              </div>

              <div className="topleftdataContainer">
                <div className="listTopDataValueText">5</div>
                <div>Total Pending Receipt</div>
              </div>
              <div className="topleftdataContainer">
                <div className="listTopDataValueText">5</div>
                <div>Total UnPaid Amount</div>
              </div>
              <div className="topleftdataContainer">
                <div className="listTopDataValueText">5</div>
                <div>Total Paid Amount</div>
              </div>

              <div
                // key={}
                className=""
              >
                <div className="listTopDataValueText">4</div>
                <div>Total Paid Receipt</div>
              </div>
            </div>
          </div><div className="tableWrapper">
              <div className="ReceiptfilterView mt-2 mb-2">
                <div className="ReceiptTableContainer gap-2">
                  <h5>All Receipts List</h5>
                  <div className="searchinput-wrapper">
                    <input
                      type="text"
                      className="searchinput"
                      placeholder="Search by Name"
                      value={searchQuery}
                      onChange={(e) => {
                        handleSearchChange(e); 
              
                     
                        if (e.target.value === "") {
                          fetchJobCardInvoiceList(); 
                        }
                      }}
                        onKeyPress={(e)=>handleKeyPress(e)}
                        
                       />
                    <img src={searchIcon} alt="Search" className="searchinput-icon" />
                  </div>
                </div>
              </div>
              <CustomTable
                data={jobCardInvoiceData || []}
                headers={TABLE_HEADERS}
                keyMapping={KEY_MAPPING}
                onEdit={handleEdit} // Pass the handleEdit function
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                totalRecords={totalRecords}
                handleViewButton={handleEdit}
                handleDownloadButton={handleDownloadInvoice} />
            </div><Drawer
              size={400}
              open={isOpen}
              onClose={toggleDrawer}
              direction="right"
              className="bla bla bla"
            >
              <div style={{ padding: "30px" }}>
                <div className="backbutton">
                  <img src={backicon} alt="back" />
                  <span className="backbtntitleDetails">Add Receipt</span>
                </div>

                <div className="mt-3">
                  <AddReceipt
                    isEdit={isEdit}
                    isOpen={isOpen}
                    toggleDrawer={toggleDrawer}
                    setIsEdit={setIsEdit} />
                </div>
                <hr />
              </div>
            </Drawer></>

  )}
  </div>
  );
};

export default ReceiptList;
